const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = query
    ? '?' + Object.entries(query).filter(([_, v]) => v !== undefined && v !== '').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
    : '';
  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const talentsApi = {
  list:        (opts)        => request('/talents',                { query: opts }),
  get:         (id)          => request(`/talents/${id}`),
  adminList:   (token, opts) => request('/admin/talents',          { token, query: opts }),
  adminGet:    (token, id)   => request(`/admin/talents/${id}`,    { token }),
  adminCreate: (token, body) => request('/admin/talents',          { method: 'POST',   token, body }),
  adminUpdate: (token, id, b)=> request(`/admin/talents/${id}`,    { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)   => request(`/admin/talents/${id}`,    { method: 'DELETE', token }),
};

export const TALENT_CATEGORIES = [
  { id: 'all',          lbl: 'Tous' },
  { id: 'art',          lbl: 'Artistes' },
  { id: 'sport',        lbl: 'Sport' },
  { id: 'entrepreneur', lbl: 'Entrepreneurs' },
  { id: 'createur',     lbl: 'Créateurs' },
  { id: 'aine',         lbl: 'Aînés' },
  { id: 'autre',        lbl: 'Autre' },
];

export const SOCIAL_TYPES = [
  { id: 'ig',  lbl: 'Instagram', short: 'IG' },
  { id: 'fb',  lbl: 'Facebook',  short: 'FB' },
  { id: 'x',   lbl: 'X / Twitter', short: 'X' },
  { id: 'yt',  lbl: 'YouTube',   short: 'YT' },
  { id: 'sp',  lbl: 'Spotify',   short: 'SP' },
  { id: 'sh',  lbl: 'Shop',      short: 'SH' },
  { id: 'tt',  lbl: 'TikTok',    short: 'TT' },
  { id: 'web', lbl: 'Site web',  short: '🌐' },
];

export const CATEGORY_LABEL = Object.fromEntries(TALENT_CATEGORIES.map((c) => [c.id, c.lbl]));
export const SOCIAL_SHORT   = Object.fromEntries(SOCIAL_TYPES.map((s) => [s.id, s.short]));
export const SOCIAL_LABEL   = Object.fromEntries(SOCIAL_TYPES.map((s) => [s.id, s.lbl]));
